import { ReactNode } from 'react';
import cn from 'classnames';

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export const Container = ({ children, className }: ContainerProps) => (
  <div className={cn('container', className)}>{children}</div>
);
